import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type FormCardV2Props = {
  title?: string;
  description?: ReactNode;
  titleKey?: string;
  descriptionKey?: string;
  children: ReactNode;
  actions?: ReactNode;
};

export function FormCardV2({ title, description, titleKey, descriptionKey, children, actions }: FormCardV2Props) {
  const { t } = useTranslation();
  const resolvedTitle = titleKey ? t(titleKey) : title;
  const resolvedDescription = descriptionKey ? t(descriptionKey) : description;

  return (
    <section className="ov2-card">
      {(resolvedTitle || resolvedDescription || actions) && (
        <header className="ov2-card__header">
          <div>
            {resolvedTitle && <h2>{resolvedTitle}</h2>}
            {resolvedDescription && <p>{resolvedDescription}</p>}
          </div>
          {actions && <div className="ov2-card__actions">{actions}</div>}
        </header>
      )}
      <div className="ov2-card__body">{children}</div>
    </section>
  );
}
